import { render } from "./ConfirmPassword.vue?vue&type=template&id=475ae21d"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/ConfirmPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "475ae21d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('475ae21d', __exports__)) {
    console.log('reload')
    api.reload('475ae21d', __exports__)
  }
  
  module.hot.accept("./ConfirmPassword.vue?vue&type=template&id=475ae21d", () => {
    console.log('re-render')
    api.rerender('475ae21d', render)
  })

}


export default __exports__